import React, { FC, ReactElement } from 'react'
import { Option } from '../Option/Option'
import style from './PositionOption.module.css'

type PositionOptionProps = {
  isActive: boolean
  optionName: string
  inputValue: string
}

const renderValue = (inputValue: string, optionName: string): Array<ReactElement> | string => {
  const nodes: Array<ReactElement> = []
  const escapedInputValue = inputValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const inputValueRegExp = new RegExp(escapedInputValue, 'ig')
  let result
  let prevIndex = 0

  if (inputValue) {
    do {
      result = inputValueRegExp.exec(optionName)

      if (result) {
        nodes.push(<span key={nodes.length}>{optionName.substring(prevIndex, result.index)}</span>)
        nodes.push(
          <span key={nodes.length} className={style.coincidence}>
            {optionName.substring(result.index, result.index + inputValue.length)}
          </span>,
        )

        prevIndex = result.index + inputValue.length
      } else {
        nodes.push(<span key={nodes.length}>{optionName.substring(prevIndex)}</span>)
      }
    } while (result)

    return nodes
  }

  return optionName
}

export const PositionOption: FC<PositionOptionProps> = ({ optionName, isActive, inputValue }): ReactElement => (
  <Option isActive={isActive}>{renderValue(inputValue, optionName)}</Option>
)

PositionOption.displayName = 'PositionOption'
